module.exports = __webpack_public_path__ + "static/media/paso 2.88dbfdef.png";